// Copyright (C) 2019-2021 Intel Corporation
//
// SPDX-License-Identifier: MIT

module.exports = {
    basename: '',
    backendAPI: '/api/v1',
    proxy: false,
};
